import { render, staticRenderFns } from "./complete_dosage_cart.vue?vue&type=template&id=0988cc3e&scoped=true&"
import script from "./complete_dosage_cart.vue?vue&type=script&lang=js&"
export * from "./complete_dosage_cart.vue?vue&type=script&lang=js&"
import style0 from "./complete_dosage_cart.vue?vue&type=style&index=0&id=0988cc3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0988cc3e",
  null
  
)

export default component.exports